export default __webpack_public_path__ + "static/media/project4.33e89a1d.webp";